export interface IInviteCode {
  code: string;
  isExpired: boolean;
  expiresAt: Date;
}
export interface ITeacherClassroomCodeDTO {
  inviteCode: IInviteCode;
}

export class TeacherClassroomCodeDTO implements ITeacherClassroomCodeDTO {
  inviteCode: IInviteCode = null;

  constructor(configOverride?: Partial<ITeacherClassroomCodeDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITeacherClassListItemDTO {
  id: string;
  className: string;
  classIcon: string;
  gradeLevel: string;
  schoolPeriodId: number;
  classroomInvites: ITeacherClassroomCodeDTO[];
}

export class TeacherClassListItemDTO implements ITeacherClassListItemDTO {
  id: string = '';
  className: string = '';
  classIcon: string = '';
  gradeLevel: string = '';
  schoolPeriodId: number = 0;
  classroomInvites: ITeacherClassroomCodeDTO[] = [];

  constructor(configOverride?: Partial<ITeacherClassListItemDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITeacherClassDetailDTO {
  id: string;
  className: string;
  classIcon: string;
  gradeLevel: string;
  schoolPeriodId: number;
  classroomInvites: ITeacherClassroomCodeDTO[];
}

export class TeacherClassDetailDTO implements ITeacherClassDetailDTO {
  id: string = '';
  className: string = '';
  classIcon: string = '';
  gradeLevel: string = '';
  schoolPeriodId: number = 0;
  classroomInvites: ITeacherClassroomCodeDTO[] = [];

  constructor(configOverride?: Partial<ITeacherClassDetailDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITeacherClassDetailRequestDTO {
  className: string;
  classIcon: string;
  gradeLevel: string;
  schoolPeriodId: number;
}

export class TeacherClassDetailRequestDTO
  implements ITeacherClassDetailRequestDTO
{
  className: string = '';
  classIcon: string = '';
  gradeLevel: string = '';
  schoolPeriodId: number = 0;

  constructor(configOverride?: Partial<ITeacherClassDetailRequestDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITeacherClassroomCodeRequestDTO {
  classId: string;
}

export class TeacherClassroomCodeRequestDTO
  implements ITeacherClassroomCodeRequestDTO
{
  classId: string = '';

  constructor(configOverride?: Partial<ITeacherClassroomCodeRequestDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
